import { toStoreDateString } from '@/common/helpers/dates'
import {
  hasCriteriaLimit,
  hasDateLimit,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/hooks/useBlockVisibility/helpers'

const getDateParts = (dateString, language) => {
  return new Intl.DateTimeFormat(language, { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' })
    .formatToParts(new Date(dateString))
    .reduce((acc, part) => ({ ...acc, [part.type]: part.value }), {})
}

const formatBadgeDate = (dateString, language) => {
  const { day, month, year } = getDateParts(dateString, language)

  return `${day} ${month.replace('.', '').toUpperCase()} ${year}`
}

const getDateLabel = (visibility, t, language, timeZone) => {
  const from = toStoreDateString(visibility.visible_from, timeZone)
  const until = toStoreDateString(visibility.visible_until, timeZone)

  if (from && until) return `${formatBadgeDate(from, language)} – ${formatBadgeDate(until, language)}`
  if (from) return t('Desde {{date}}', { date: formatBadgeDate(from, language) })

  return t('Hasta {{date}}', { date: formatBadgeDate(until, language) })
}

export const getVisibilityBadges = ({ visibility, t, language, timeZone }) => {
  const badges = { dateLabel: null, rulesLabel: null }

  if (!hasDateLimit(visibility) && !hasCriteriaLimit(visibility)) return badges

  badges.dateLabel = hasDateLimit(visibility) ? getDateLabel(visibility, t, language, timeZone) : t('Siempre')

  if (hasCriteriaLimit(visibility)) {
    badges.rulesLabel = t('{{count}} reglas', { count: visibility.visibility_criterion_ids.length })
  }

  return badges
}
